import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import TableComponent from "../../../shared/components/table";
import { SortingState } from "@tanstack/react-table";

const docketData = [
  {
    sn: 1,
    assigned_date: "31-05-2024",
    case_title: "Olugbenga Akintola vs Israel Anyemalu",
    appeal_number: "A/A/2024",
    status: "Assigned To Court",
  },
  {
    sn: 2,
    assigned_date: "31-05-2024",
    case_title: "Olugbenga Akintola vs Israel Anyemalu",
    appeal_number: "SC/2/2025",
    status: "Assigned To Court",
  },
  {
    sn: 3,
    assigned_date: "31-05-2024",
    case_title: "Olugbenga Akintola vs Israel Anyemalu",
    appeal_number: "Civil",
    status: "Assigned To Court",
  },
];

const PanelsDocket = () => {
  const [sorting, setSorting] = useState<SortingState>([]);
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="flex flex-col h-full min-h-screen">
      <div className="bg-white px-8 py-6 border-b border-[#E5E7EB]">
        <div className="flex items-center gap-x-2 text-sm text-[#6B7280] mb-4">
          <Link to="/president/overview" className="hover:text-[#111827]">
            Home
          </Link>
          <span>&gt;</span>
          <span>Case folder</span>
          <span>&gt;</span>
          <span>Panels</span>
          <span>&gt;</span>
          <span className="font-medium text-[#111827]">Docket</span>
        </div>
        <h1 className="text-2xl font-bold text-[#111827]">Dockets</h1>
      </div>

      <div className="bg-white border-b border-[#E5E7EB] px-8 pt-6">
        <button className="pb-3 border-b-2 border-[#111827] text-sm font-medium text-[#111827]">
          Dockets
        </button>
      </div>

      <div className="px-8 py-6">
        <div className="relative w-full max-w-[320px]">
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-4 pr-10 py-2.5 rounded-lg border border-[#D1D5DB] focus:outline-none focus:border-[#111827] bg-white text-sm"
          />
          <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#9CA3AF]" />
        </div>
      </div>

      <div className="flex-1 px-8 pb-10">
        <div className="bg-white overflow-auto">
          <table className="min-w-full border-collapse">
            <thead>
              <tr className="bg-[#F9FAFB] text-xs font-medium text-[#6B7280]">
                <th className="text-left px-6 py-3">SN</th>
                <th className="text-left px-6 py-3">Assigned Date</th>
                <th className="text-left px-6 py-3">Case Title</th>
                <th className="text-left px-6 py-3">Appeal Number</th>
                <th className="text-left px-6 py-3">Status</th>
                <th className="text-left px-6 py-3">View Details</th>
                <th className="text-left px-6 py-3">Action</th>
              </tr>
            </thead>
            <tbody>
              {docketData.map((row) => (
                <tr key={row.sn} className="text-sm text-[#111827]">
                  <td className="px-6 py-4 align-top">{row.sn}</td>
                  <td className="px-6 py-4 align-top">{row.assigned_date}</td>
                  <td className="px-6 py-4 align-top">{row.case_title}</td>
                  <td className="px-6 py-4 align-top">{row.appeal_number}</td>
                  <td className="px-6 py-4 align-top">
                    <span className="inline-flex items-center justify-center px-4 py-1 rounded-full border border-[#FBBF24] bg-[#FFFBEB] text-[#92400E] text-xs font-medium">
                      Assigned To Court
                    </span>
                  </td>
                  <td className="px-6 py-4 align-top">
                    <button className="text-[#00B074] text-sm font-medium">
                      View
                    </button>
                  </td>
                  <td className="px-6 py-4 align-top">
                    <button className="text-[#00B074] text-sm font-medium">
                      Assign
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="flex items-center justify-between px-6 py-4 border-t border-[#E5E7EB] text-sm text-[#6B7280]">
            <span>
              Page <span className="font-medium">1</span> of{" "}
              <span className="font-medium">10</span>
            </span>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <button className="px-3 py-1.5 rounded-lg border border-[#D1D5DB] bg-white hover:bg-gray-50">
                  Previous
                </button>
                <button className="px-3 py-1.5 rounded-lg border border-[#D1D5DB] bg-white hover:bg-gray-50">
                  Next
                </button>
              </div>
              <div className="flex items-center gap-2">
                <span>Entries per page:</span>
                <select className="border border-[#D1D5DB] rounded-lg px-2 py-1 bg-white focus:outline-none text-sm">
                  <option>10</option>
                  <option>20</option>
                  <option>50</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PanelsDocket;
